import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { FaPencilAlt, FaTrash, FaPlus } from 'react-icons/fa';
import { apiURL1 } from '../../config';
import Footer from 'components/Footers/Footer';


const LeaveQuota = () => {
    const token = localStorage.getItem("token");

    const [leaveTypes, setLeaveTypes] = useState([]);
    const [leaveQuotas, setLeaveQuotas] = useState([]);
    const [newLeaveType, setNewLeaveType] = useState('');
    const [newQuota, setNewQuota] = useState('');
    const [editQuotaId, setEditQuotaId] = useState(null);
    const [editLeaveType, setEditLeaveType] = useState('');
    const [editQuota, setEditQuota] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        fetchLeaveTypes();
        fetchLeaveQuotas();
    }, []);

    const fetchLeaveTypes = async () => {
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/types`, {
                method: 'GET', // or any other HTTP method as needed
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                },
            });
            const data = await response.json();
            setLeaveTypes(data);
        } catch (error) {
            console.error('Error fetching leave types:', error);
            toast.error('Error fetching leave types!');
        }
    };

    const fetchLeaveQuotas = async () => {
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/quotas`, {
                method: 'GET', // or any other HTTP method as needed
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                },
            });
            const data = await response.json();
            setLeaveQuotas(data);
        } catch (error) {
            console.error('Error fetching leave quotas:', error);
            toast.error('Error fetching leave quotas!');
        }
    };

    const handleAddLeaveQuota = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/quotas`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({ leaveType: newLeaveType, quota: newQuota }),
            });
            if (response.ok) {
                toast.success('Leave quota added successfully!');
                fetchLeaveQuotas();
                setNewLeaveType('');
                setNewQuota('');
                setModalOpen(false);
            } else {
                toast.error('Error adding leave quota!');
            }
        } catch (error) {
            console.error('Error adding leave quota:', error);
            toast.error('Error adding leave quota!');
        }
    };

    const handleEditLeaveQuota = (leaveQuota) => {
        setEditQuotaId(leaveQuota._id);
        setEditLeaveType(leaveQuota.leaveType._id);
        setEditQuota(leaveQuota.quota);
        setEditModalOpen(true);
    };

    const handleUpdateLeaveQuota = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/quotas/${editQuotaId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({ leaveType: editLeaveType, quota: editQuota }),
            });
            if (response.ok) {
                toast.success('Leave quota updated successfully!');
                fetchLeaveQuotas();
                setEditQuotaId(null);
                setEditLeaveType('');
                setEditQuota('');
                setEditModalOpen(false);
            } else {
                toast.error('Error updating leave quota!');
            }
        } catch (error) {
            console.error('Error updating leave quota:', error);
            toast.error('Error updating leave quota!');
        }
    };

    const handleDeleteLeaveQuota = async (id) => {
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/quotas/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                },
            });
            if (response.ok) {
                toast.success('Leave quota deleted successfully!');
                fetchLeaveQuotas();
            } else {
                toast.error('Error deleting leave quota!');
            }
        } catch (error) {
            console.error('Error deleting leave quota:', error);
            toast.error('Error deleting leave quota!');
        }
    };

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-2 text-white">Leave Quota</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage leave quotas for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Leave Quotas</h3>
                                <Button color="primary" size="sm" onClick={() => setModalOpen(true)}>
                                    <FaPlus /> Add New
                                </Button>
                            </CardHeader>
                            <CardBody>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Leave Type</th>
                                            <th>Quota</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {leaveQuotas && leaveQuotas.length > 0 ? (
                                            leaveQuotas.map((leaveQuota) => (
                                                <tr key={leaveQuota._id}>
                                                    <td>{leaveQuota.leaveType.name}</td>
                                                    <td>{leaveQuota.quota}</td>
                                                    <td>
                                                        <>
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() => handleEditLeaveQuota(leaveQuota)}
                                                            >
                                                                <FaPencilAlt />
                                                            </Button>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteLeaveQuota(leaveQuota._id)}
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3">No leave quotas found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add New Leave Quota</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddLeaveQuota}>
                        <FormGroup>
                            <Label>Leave Type</Label>
                            <Input
                                type="select"
                                value={newLeaveType}
                                onChange={(e) => setNewLeaveType(e.target.value)}
                            >
                                <option value="">Select Leave Type</option>
                                {leaveTypes.map((leaveType) => (
                                    <option key={leaveType._id} value={leaveType._id}>
                                        {leaveType.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Quota</Label>
                            <Input
                                type="number"
                                placeholder="Enter quota"
                                value={newQuota}
                                onChange={(e) => setNewQuota(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Leave Quota
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Leave Quota</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateLeaveQuota}>
                        <FormGroup>
                            <Label>Leave Type</Label>
                            <Input
                                type="select"
                                value={editLeaveType}
                                onChange={(e) => setEditLeaveType(e.target.value)}
                            >
                                <option value="">Select Leave Type</option>
                                {leaveTypes.map((leaveType) => (
                                    <option key={leaveType._id} value={leaveType._id}>
                                        {leaveType.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Quota</Label>
                            <Input
                                type="number"
                                placeholder="Enter quota"
                                value={editQuota}
                                onChange={(e) => setEditQuota(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Leave Quota
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>

            </Modal>
            <Footer />
        </>
    );
};

export default LeaveQuota;
